import { ThemeProvider as NextThemesProvider } from "next-themes";
import { type ReactNode } from "react";

/**
 * BDCG is a dark-only brand experience. We force the dark theme
 * across every surface (public site, client portal, admin portal)
 * and ignore the device's light/dark setting.
 */
export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="dark"
      forcedTheme="dark"
      enableSystem={false}
      enableColorScheme={false}
    >
      {children}
    </NextThemesProvider>
  );
}
